var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarnings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 90 90",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 56.614 14.764 c 0.054 -2.224 3.255 -7.706 3.676 -9.297 c 0.314 -1.186 -0.575 -2.347 -1.802 -2.347 H 43.321 c -1.227 0 -2.116 1.161 -1.802 2.347 c 0.421 1.591 3.622 7.073 3.676 9.297",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(142,191,48)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 77.335 58.77 c -1.508 -5.694 -2.227 -12.746 -2.419 -20.706 c 0 -11.29 -7.802 -20.734 -18.302 -23.3 h 0 h -11.42 h 0 c -10.5 2.566 -18.302 12.01 -18.302 23.3 c -0.112 4.626 -0.401 8.945 -0.92 12.87 l -1.773 15.863 l 22.886 8.517 l 32.819 -6.959 L 77.335 58.77 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(142,191,48)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 59.93,
    rx: 0,
    ry: 0,
    width: 13.53,
    height: 26.95,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(67,152,209)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 88.813 67.525 c -0.63 -2.057 -2.689 -3.321 -4.807 -2.944 c -6.373 1.135 -14.088 3.499 -21.357 5.203 l -0.001 -0.001 l 0.001 0 c -0.371 -4.127 -3.759 -7.33 -7.9 -7.47 l -1.88 -0.063 c -6.139 0 -12.818 -4.463 -18.501 -4.463 c -4.996 0 -9.819 1.085 -15.128 5.724 c -0.672 0.587 -1.535 0.919 -2.427 0.912 l -1.823 -0.083 v 17.597 h 5.353 c 1.687 0 3.369 0.185 5.015 0.552 l 14.402 3.211 c 1.3 0.29 2.63 0.427 3.962 0.407 l 7.97 -0.116 c 2.234 -0.032 4.439 -0.503 6.492 -1.386 l 28.241 -11.927 C 88.419 71.824 89.448 69.601 88.813 67.525 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,222,198)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62.647 70.784 c -0.512 0 -0.948 -0.391 -0.995 -0.91 c -0.325 -3.617 -3.308 -6.437 -6.938 -6.561 l -1.88 -0.063 c 0 0 -0.001 0 -0.002 0 c -3.267 0.001 -6.639 -1.195 -9.901 -2.353 c -3.059 -1.085 -5.949 -2.109 -8.563 -2.109 c -4.055 0 -8.945 0.65 -14.47 5.478 c -0.866 0.756 -1.977 1.143 -3.093 1.159 l -2.322 -0.104 c -0.552 -0.025 -0.979 -0.492 -0.954 -1.044 c 0.025 -0.553 0.499 -0.979 1.044 -0.954 l 2.285 0.104 c 0.589 -0.043 1.227 -0.232 1.724 -0.666 c 6.023 -5.263 11.359 -5.972 15.786 -5.972 c 2.959 0 6.148 1.131 9.232 2.225 c 3.103 1.101 6.313 2.238 9.269 2.238 l 1.914 0.064 c 4.637 0.156 8.446 3.759 8.862 8.379 c 0.05 0.551 -0.356 1.036 -0.906 1.086 C 62.708 70.783 62.678 70.784 62.647 70.784 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(117,101,180)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 43.472 87.112 c -1.321 0 -2.642 -0.146 -3.931 -0.434 L 25.14 83.468 c -1.573 -0.351 -3.187 -0.528 -4.798 -0.528 h -5.814 c -0.552 0 -1 -0.447 -1 -1 c 0 -0.553 0.448 -1 1 -1 h 5.814 c 1.757 0 3.518 0.194 5.233 0.577 l 14.401 3.211 c 1.222 0.271 2.476 0.393 3.729 0.383 l 7.97 -0.116 c 2.113 -0.03 4.17 -0.47 6.111 -1.305 l 28.248 -11.929 c 1.522 -0.655 2.309 -2.352 1.821 -3.942 c -0.48 -1.573 -2.058 -2.544 -3.676 -2.253 c -3.898 0.694 -8.247 1.838 -12.851 3.049 c -12.497 3.287 -25.421 6.686 -31.219 1.368 c -0.407 -0.374 -0.435 -1.006 -0.061 -1.413 c 0.373 -0.406 1.005 -0.435 1.413 -0.062 c 4.995 4.583 17.937 1.175 29.358 -1.827 c 4.645 -1.222 9.031 -2.376 13.01 -3.084 c 2.605 -0.464 5.162 1.099 5.937 3.637 c 0.786 2.567 -0.481 5.305 -2.949 6.367 L 58.571 85.529 c -2.178 0.937 -4.489 1.431 -6.866 1.465 l -7.97 0.116 C 43.647 87.111 43.56 87.112 43.472 87.112 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(117,101,180)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14.528 87.88 H 1 c -0.552 0 -1 -0.447 -1 -1 V 59.93 c 0 -0.553 0.448 -1 1 -1 h 13.527 c 0.552 0 1 0.447 1 1 v 26.95 C 15.528 87.432 15.08 87.88 14.528 87.88 z M 2 85.88 h 11.527 V 60.93 H 2 V 85.88 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(117,101,180)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 56.614 15.764 c -0.008 0 -0.016 0 -0.024 0 c -0.552 -0.013 -0.988 -0.472 -0.976 -1.023 c 0.039 -1.622 1.336 -4.338 2.48 -6.734 c 0.564 -1.184 1.098 -2.301 1.229 -2.794 c 0.07 -0.265 0.016 -0.54 -0.15 -0.755 c -0.164 -0.214 -0.414 -0.336 -0.685 -0.336 H 43.321 c -0.271 0 -0.52 0.123 -0.685 0.336 c -0.166 0.215 -0.221 0.49 -0.15 0.754 c 0.13 0.494 0.664 1.611 1.229 2.795 c 1.144 2.396 2.44 5.112 2.479 6.734 c 0.014 0.552 -0.423 1.01 -0.976 1.023 c -0.523 0.012 -1.011 -0.423 -1.023 -0.976 c -0.029 -1.194 -1.333 -3.926 -2.286 -5.921 c -0.659 -1.38 -1.179 -2.47 -1.357 -3.144 c -0.23 -0.869 -0.048 -1.775 0.499 -2.486 c 0.546 -0.709 1.373 -1.117 2.27 -1.117 h 15.167 c 0.896 0 1.724 0.407 2.27 1.117 c 0.548 0.711 0.729 1.618 0.499 2.487 c -0.179 0.674 -0.699 1.764 -1.357 3.144 c -0.952 1.995 -2.257 4.727 -2.285 5.921 C 57.6 15.332 57.155 15.764 56.614 15.764 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(117,101,180)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 77.335 59.77 c -0.442 0 -0.847 -0.296 -0.966 -0.744 c -1.442 -5.446 -2.244 -12.295 -2.452 -20.938 c 0 -10.607 -7.159 -19.761 -17.425 -22.324 H 45.316 c -10.265 2.563 -17.424 11.717 -17.424 22.3 c -0.117 4.859 -0.43 9.225 -0.929 13 c -0.072 0.548 -0.572 0.935 -1.123 0.86 c -0.547 -0.072 -0.933 -0.575 -0.86 -1.122 c 0.49 -3.705 0.797 -7.999 0.912 -12.763 c 0 -11.523 7.839 -21.504 19.064 -24.247 c 0.078 -0.019 0.157 -0.029 0.237 -0.029 h 11.419 c 0.08 0 0.16 0.01 0.237 0.029 c 11.226 2.743 19.065 12.724 19.065 24.271 c 0.204 8.46 0.984 15.158 2.386 20.451 c 0.142 0.534 -0.177 1.081 -0.711 1.223 C 77.506 59.76 77.42 59.77 77.335 59.77 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(117,101,180)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50.751 49.793 c -0.804 0 -1.604 -0.172 -2.358 -0.515 c -1.388 -0.631 -2.447 -1.764 -2.982 -3.191 c -0.194 -0.517 0.068 -1.093 0.585 -1.288 c 0.515 -0.192 1.093 0.068 1.288 0.585 c 0.348 0.927 1.035 1.663 1.937 2.073 c 0.901 0.41 1.908 0.443 2.835 0.096 c 0.928 -0.348 1.664 -1.035 2.074 -1.937 c 0.409 -0.901 0.443 -1.908 0.096 -2.835 c -0.411 -1.097 -1.296 -1.916 -2.426 -2.248 l -2.414 -0.882 c -1.677 -0.491 -3.038 -1.753 -3.673 -3.445 c -0.535 -1.427 -0.483 -2.978 0.148 -4.365 c 0.631 -1.388 1.764 -2.447 3.191 -2.982 c 1.43 -0.534 2.979 -0.482 4.366 0.148 c 1.388 0.631 2.446 1.764 2.981 3.191 c 0.193 0.518 -0.068 1.094 -0.586 1.288 c -0.513 0.191 -1.093 -0.068 -1.287 -0.585 c -0.348 -0.927 -1.035 -1.663 -1.937 -2.073 c -0.901 -0.41 -1.908 -0.444 -2.836 -0.096 c -0.927 0.348 -1.662 1.035 -2.072 1.937 c -0.409 0.901 -0.443 1.908 -0.096 2.835 c 0.411 1.097 1.295 1.916 2.426 2.249 l 2.413 0.882 c 1.678 0.49 3.039 1.752 3.674 3.444 c 0.535 1.427 0.482 2.978 -0.148 4.366 c -0.631 1.388 -1.765 2.446 -3.192 2.981 C 52.105 49.671 51.428 49.793 50.751 49.793 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(117,101,180)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50.904 30.502 c -0.553 0 -1 -0.448 -1 -1 v -2.63 c 0 -0.552 0.447 -1 1 -1 s 1 0.448 1 1 v 2.63 C 51.904 30.054 51.457 30.502 50.904 30.502 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(117,101,180)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50.904 52.415 c -0.553 0 -1 -0.447 -1 -1 v -2.63 c 0 -0.553 0.447 -1 1 -1 s 1 0.447 1 1 v 2.63 C 51.904 51.968 51.457 52.415 50.904 52.415 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(117,101,180)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnings);
export default __webpack_public_path__ + "static/media/earnings.f2e1c0ed4705b8770c2bed0e6eb5bb22.svg";
export { ForwardRef as ReactComponent };